import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useCpaStore } from '@liscio/common';

/**
 * Capture firm-targeting query parameters and store to state.
 *
 * Senders identify the firm a view must render with either (or both):
 * - `cpa_uuid` — exact firm key, same identifier the switch-cpa mutation
 *   uses. Preferred: no string matching involved.
 * - `company_name` — firm host, matched against cpa urls (normalized).
 *   Kept for legacy-app redirects that only know the host.
 */
export const COMPANY_NAME_PARAM = 'company_name';
export const CPA_UUID_PARAM = 'cpa_uuid';
export const useCaptureCompanyName = () => {
  const [searchParams] = useSearchParams();
  const companyNameParam = searchParams.get(COMPANY_NAME_PARAM);
  const cpaUuidParam = searchParams.get(CPA_UUID_PARAM);
  const setQueryCompany = useCpaStore(({ setQueryCompany }) => setQueryCompany);
  const setQueryCpaUuid = useCpaStore(({ setQueryCpaUuid }) => setQueryCpaUuid);

  useEffect(() => {
    if (companyNameParam) {
      setQueryCompany(companyNameParam);
      // NOTE: We might want to store this in secure storage between sessions
      // We can revisit that when we get to custom firm theming
    }
    if (cpaUuidParam) {
      setQueryCpaUuid(cpaUuidParam);
    }
  }, [companyNameParam, cpaUuidParam, setQueryCompany, setQueryCpaUuid]);
};
